<template>
  <div v-if="project.reference_number" class="details-wrapper">
    <div class="details-body">
      <div class="content-panel-wrapper">
        <div v-scroll-spy data-scroll-spy-id="main-tab" class="content-panel">
          <section class="details-section">
            <ProjectDetailsForm :project="project" />
          </section>
          <section class="details-section">
            <h1>{{ $t('projects.details.contacts.clientContacts') }}</h1>
            <div class="add">
              <span @click="addClientContact">+</span>
            </div>
            <div v-if="project.client_contacts.length > 0" class="details-list">
              <tol-table
                :table-data="project.client_contacts"
                :columns="contactsColumns"
                data-label-prefix="clientContacts"
                :is-row-clickable="true"
                @row-click="onContactRowClick($event)"
              >
                <template v-slot:tableHeader>
                  <th-sortable
                    :direction="
                      currentSortFieldForClientContacts === 'role'
                        ? currentSortDirectionForClientContacts
                        : 'none'
                    "
                    field-name="role"
                    @change="onClientContactsSortOrderChange"
                  >
                    {{ $t('projects.details.contacts.labels.role') }}
                  </th-sortable>
                  <th-sortable
                    :direction="
                      currentSortFieldForClientContacts === 'first_name'
                        ? currentSortDirectionForClientContacts
                        : 'none'
                    "
                    field-name="first_name"
                    @change="onClientContactsSortOrderChange"
                  >
                    {{ $t('projects.details.contacts.labels.firstName') }}
                  </th-sortable>
                  <th-sortable
                    :direction="
                      currentSortFieldForClientContacts === 'last_name'
                        ? currentSortDirectionForClientContacts
                        : 'none'
                    "
                    field-name="last_name"
                    @change="onClientContactsSortOrderChange"
                  >
                    {{ $t('projects.details.contacts.labels.lastName') }}
                  </th-sortable>
                  <th-sortable
                    :direction="
                      currentSortFieldForClientContacts === 'email'
                        ? currentSortDirectionForClientContacts
                        : 'none'
                    "
                    field-name="email"
                    @change="onClientContactsSortOrderChange"
                  >
                    {{ $t('projects.details.contacts.labels.email') }}
                  </th-sortable>
                  <th-sortable
                    :direction="
                      currentSortFieldForClientContacts === 'phone_number'
                        ? currentSortDirectionForClientContacts
                        : 'none'
                    "
                    field-name="phone_number"
                    @change="onClientContactsSortOrderChange"
                  >
                    {{ $t('projects.details.contacts.labels.phoneNumber') }}
                  </th-sortable>
                </template>
                <template v-slot:referenceNumber="{ value }">
                  <router-link :to="'/users/' + value.user_reference_number">
                    {{ value.user_reference_number }}
                  </router-link>
                </template>
              </tol-table>
            </div>
            <div v-if="project.client_contacts.length === 0">
              <div class="empty">
                {{ $t('projects.details.errors.noRecords', { record: 'Client Contacts' }) }}
              </div>
            </div>
          </section>
          <section class="details-section">
            <h1>{{ $t('projects.details.contacts.tesContacts') }}</h1>
            <div class="add">
              <span @click="addTesContact">+</span>
            </div>
            <div v-if="project.tes_contacts.length > 0" class="details-list">
              <tol-table
                :table-data="project.tes_contacts"
                :columns="contactsColumns"
                data-label-prefix="tesContacts"
                :is-row-clickable="true"
                @row-click="onContactRowClick($event)"
              >
                <template v-slot:tableHeader>
                  <th-sortable
                    :direction="
                      currentSortFieldForTESContacts === 'role'
                        ? currentSortDirectionForTESContacts
                        : 'none'
                    "
                    field-name="role"
                    @change="onTESContactsSortOrderChange"
                  >
                    {{ $t('projects.details.contacts.labels.role') }}
                  </th-sortable>
                  <th-sortable
                    :direction="
                      currentSortFieldForTESContacts === 'first_name'
                        ? currentSortDirectionForTESContacts
                        : 'none'
                    "
                    field-name="first_name"
                    @change="onTESContactsSortOrderChange"
                  >
                    {{ $t('projects.details.contacts.labels.firstName') }}
                  </th-sortable>
                  <th-sortable
                    :direction="
                      currentSortFieldForTESContacts === 'last_name'
                        ? currentSortDirectionForTESContacts
                        : 'none'
                    "
                    field-name="last_name"
                    @change="onTESContactsSortOrderChange"
                  >
                    {{ $t('projects.details.contacts.labels.lastName') }}
                  </th-sortable>
                  <th-sortable
                    :direction="
                      currentSortFieldForTESContacts === 'email'
                        ? currentSortDirectionForTESContacts
                        : 'none'
                    "
                    field-name="email"
                    @change="onTESContactsSortOrderChange"
                  >
                    {{ $t('projects.details.contacts.labels.email') }}
                  </th-sortable>
                  <th-sortable
                    :direction="
                      currentSortFieldForTESContacts === 'phone_number'
                        ? currentSortDirectionForTESContacts
                        : 'none'
                    "
                    field-name="phone_number"
                    @change="onTESContactsSortOrderChange"
                  >
                    {{ $t('projects.details.contacts.labels.phoneNumber') }}
                  </th-sortable>
                </template>
                <template v-slot:referenceNumber="{ value }">
                  <router-link :to="'/users/' + value.user_reference_number">
                    {{ value.user_reference_number }}
                  </router-link>
                </template>
              </tol-table>
            </div>
            <div v-if="project.tes_contacts.length === 0">
              <div class="empty">
                {{ $t('projects.details.errors.noRecords', { record: 'TES Contacts' }) }}
              </div>
            </div>
          </section>
          <section class="details-section">
            <tol-button
              button-type="major"
              :label="toggleTechnicians"
              :icon-name="iconFor(isListDisplayed['TECHNICIANS'])"
              @click="toggleList('TECHNICIANS')"
            />
            <div
              v-if="project.technicians.length > 0 && isListDisplayed['TECHNICIANS']"
              class="details-list"
            >
              <h1>{{ $t('projects.details.technicians.title') }}</h1>
              <tol-table
                :table-data="project.technicians"
                :columns="techniciansColumns"
                data-label-prefix="technicians"
                :is-row-clickable="true"
                @row-click="onTechnicianRowClick($event)"
              >
                <template v-slot:tableHeader>
                  <th-sortable
                    :direction="
                      currentSortFieldForTechnicians === 'first_name'
                        ? currentSortDirectionForTechnicians
                        : 'none'
                    "
                    field-name="first_name"
                    @change="onTechniciansSortOrderChange"
                  >
                    {{ $t('projects.details.technicians.labels.firstName') }}
                  </th-sortable>
                  <th-sortable
                    :direction="
                      currentSortFieldForTechnicians === 'last_name'
                        ? currentSortDirectionForTechnicians
                        : 'none'
                    "
                    field-name="last_name"
                    @change="onTechniciansSortOrderChange"
                  >
                    {{ $t('projects.details.technicians.labels.lastName') }}
                  </th-sortable>
                  <th-sortable
                    :direction="
                      currentSortFieldForTechnicians === 'email'
                        ? currentSortDirectionForTechnicians
                        : 'none'
                    "
                    field-name="email"
                    @change="onTechniciansSortOrderChange"
                  >
                    {{ $t('projects.details.technicians.labels.email') }}
                  </th-sortable>
                  <th-sortable
                    :direction="
                      currentSortFieldForTechnicians === 'phone_number'
                        ? currentSortDirectionForTechnicians
                        : 'none'
                    "
                    field-name="phone_number"
                    @change="onTechniciansSortOrderChange"
                  >
                    {{ $t('projects.details.technicians.labels.phoneNumber') }}
                  </th-sortable>
                  <th>{{ $t('projects.details.technicians.labels.comments') }}</th>
                </template>
                <template v-slot:referenceNumber="{ value }">
                  <router-link :to="'/contractors/' + value.contractor_reference_number">
                    {{ value.referenceNumber }}
                  </router-link>
                </template>
              </tol-table>
            </div>
            <div v-if="isListDisplayed['TECHNICIANS'] && project.technicians.length === 0">
              <div class="empty">
                {{ $t('projects.details.errors.noRecords', { record: 'TES Resources' }) }}
              </div>
            </div>
          </section>
          <section
            v-if="canViewAttachments && project && project.reference_number"
            class="details-section"
          >
            <tol-button
              button-type="major"
              :label="toggleAttachments"
              :icon-name="iconFor(isListDisplayed['ATTACHMENTS'])"
              @click="toggleList('ATTACHMENTS')"
            />
            <div v-if="isListDisplayed['ATTACHMENTS']" class="details-list">
              <h1>{{ $t('projects.details.attachments.title') }}</h1>
              <Attachment
                :reference-number="project.reference_number"
                owner="PROJECT"
                @attachment-success="refreshAttachments"
              />
              <AttachmentsList
                attachment-type="PROJECT"
                :attachments="projectAttachments"
                :attachment-options="attachmentOptions"
                @delete-attachment="confirmAttachmentDelete"
                @refresh="refreshAttachments"
              />
            </div>
          </section>
          <section class="details-section">
            <tol-button
              button-type="major"
              :label="toggleEventTypes"
              :icon-name="iconFor(isListDisplayed['EVENT_TYPES'])"
              @click="toggleList('EVENT_TYPES')"
            />
            <div v-if="isListDisplayed['EVENT_TYPES']">
              <div v-if="project.event_types.length > 0" class="details-list">
                <h1>{{ $t('projects.details.eventTypes.title') }}</h1>
                <tol-table
                  class="details-table"
                  :table-data="project.event_types"
                  :columns="eventTypesColumns"
                  :is-row-clickable="true"
                  data-label-prefix="eventTypes"
                  @row-click="onEventTypeRowClick($event)"
                >
                  <template v-slot:tableHeader>
                    <th-sortable
                      :direction="
                        currentSortFieldForEventTypes === 'name'
                          ? currentSortDirectionForEventTypes
                          : 'none'
                      "
                      field-name="name"
                      @change="onEventTypesSortOrderChange"
                    >
                      {{ $t('projects.details.eventTypes.labels.name') }}
                    </th-sortable>
                    <th-sortable
                      :direction="
                        currentSortFieldForEventTypes === 'estimated_hours_onsite'
                          ? currentSortDirectionForEventTypes
                          : 'none'
                      "
                      field-name="estimated_hours_onsite"
                      @change="onEventTypesSortOrderChange"
                    >
                      {{ $t('projects.details.eventTypes.labels.estimatedHoursOnsite') }}
                    </th-sortable>
                    <th-sortable
                      :direction="
                        currentSortFieldForEventTypes === 'scope_of_work'
                          ? currentSortDirectionForEventTypes
                          : 'none'
                      "
                      field-name="scope_of_work"
                      @change="onEventTypesSortOrderChange"
                    >
                      {{ $t('projects.details.eventTypes.labels.scopeOfWork') }}
                    </th-sortable>
                    <th-sortable
                      :direction="
                        currentSortFieldForEventTypes === 'status'
                          ? currentSortDirectionForEventTypes
                          : 'none'
                      "
                      field-name="status"
                      @change="onEventTypesSortOrderChange"
                    >
                      {{ $t('projects.details.eventTypes.labels.status') }}
                    </th-sortable>
                    <th>{{ $t('projects.details.eventTypes.labels.comments') }}</th>
                  </template>
                  <template v-slot:referenceNumber="{ value }">
                    <router-link
                      :to="
                        `/projects/${project.reference_number}event_types/${value.reference_number}`
                      "
                    >
                      {{ value.referenceNumber }}
                    </router-link>
                  </template>
                  <template v-slot:status="{ value }">
                    <Status :status="value.status" object-type="eventType" />
                  </template>
                </tol-table>
              </div>
              <div v-if="project.event_types.length === 0">
                <div class="empty">
                  {{ $t('projects.details.errors.noRecords', { record: 'Event Types' }) }}
                </div>
              </div>
              <div class="create-event-type-button-container">
                <TolButton
                  icon-name="plus"
                  button-type="minor"
                  class="action-round"
                  :tooltip="$t('projects.details.labels.createEventType')"
                  :label="$t('projects.details.labels.createEventType')"
                  @click="isCreateEventTypeModalDisplayed = true"
                />
              </div>
            </div>
          </section>
          <section class="details-section">
            <tol-button
              button-type="major"
              :label="togglePurchaseOrders"
              :icon-name="iconFor(isListDisplayed['PURCHASE_ORDERS'])"
              @click="toggleList('PURCHASE_ORDERS')"
            />
            <div
              v-if="project.purchase_orders.length > 0 && isListDisplayed['PURCHASE_ORDERS']"
              class="details-list"
            >
              <h1>{{ $t('projects.details.purchaseOrders.title') }}</h1>
              <tol-table
                :table-data="project.purchase_orders"
                :columns="purchaseOrdersColumns"
                data-label-prefix="purchaseOrders"
                :is-row-clickable="true"
                @row-click="onPurchaseOrderRowClick($event)"
              >
                <template v-slot:tableHeader>
                  <th-sortable
                    :direction="
                      currentSortFieldForPurchaseOrders === 'purchase_order_number'
                        ? currentSortDirectionForPurchaseOrders
                        : 'none'
                    "
                    field-name="purchase_order_number"
                    @change="onPurchaseOrdersSortOrderChange"
                  >
                    {{ $t('projects.details.purchaseOrders.labels.purchaseOrderNumber') }}
                  </th-sortable>
                  <th-sortable
                    :direction="
                      currentSortFieldForPurchaseOrders === 'start_date'
                        ? currentSortDirectionForPurchaseOrders
                        : 'none'
                    "
                    field-name="start_date"
                    @change="onPurchaseOrdersSortOrderChange"
                  >
                    {{ $t('projects.details.purchaseOrders.labels.startDate') }}
                  </th-sortable>
                  <th-sortable
                    :direction="
                      currentSortFieldForPurchaseOrders === 'end_date'
                        ? currentSortDirectionForPurchaseOrders
                        : 'none'
                    "
                    field-name="end_date"
                    @change="onPurchaseOrdersSortOrderChange"
                  >
                    {{ $t('projects.details.purchaseOrders.labels.endDate') }}
                  </th-sortable>
                  <th>{{ $t('projects.details.purchaseOrders.labels.comments') }}</th>
                </template>
                <template v-slot:referenceNumber="{ value }">
                  <router-link :to="'/purchase_orders/' + value.referenceNumber">
                    {{ value.referenceNumber }}
                  </router-link>
                </template>
                <template v-slot:status="{ value }">
                  <Status :status="value.status" object-type="purchaseOrder" />
                </template>
              </tol-table>
            </div>
            <div v-if="isListDisplayed['PURCHASE_ORDERS'] && project.purchase_orders.length === 0">
              <div class="empty">
                {{ $t('projects.details.errors.noRecords', { record: 'Purchase Orders' }) }}
              </div>
            </div>
          </section>
          <section class="details-section">
            <tol-button
              button-type="major"
              :label="toggleTravelRates"
              :icon-name="iconFor(isListDisplayed['TRAVEL_RATES'])"
              @click="toggleList('TRAVEL_RATES')"
            />
            <div
              v-if="project.travel_rates.length > 0 && isListDisplayed['TRAVEL_RATES']"
              class="details-list"
            >
              <h1>{{ $t('projects.details.travelRates.title') }}</h1>
              <tol-table
                :table-data="project.travel_rates"
                :columns="travelRatesColumns"
                data-label-prefix="travelRates"
              >
                <template v-slot:tableHeader>
                  <th-sortable
                    :direction="
                      currentSortFieldForTravelRates === 'description'
                        ? currentSortDirectionForTravelRates
                        : 'none'
                    "
                    field-name="description"
                    @change="onTravelRatesSortOrderChange"
                  >
                    {{ $t('projects.details.travelRates.labels.description') }}
                  </th-sortable>
                  <th-sortable
                    :direction="
                      currentSortFieldForTravelRates === 'fixed_or_actual'
                        ? currentSortDirectionForTravelRates
                        : 'none'
                    "
                    field-name="fixed_or_actual"
                    @change="onTravelRatesSortOrderChange"
                  >
                    {{ $t('projects.details.travelRates.labels.fixedActual') }}
                  </th-sortable>
                  <th-sortable
                    :direction="
                      currentSortFieldForTravelRates === 'technician_rate'
                        ? currentSortDirectionForTravelRates
                        : 'none'
                    "
                    field-name="technician_rate"
                    @change="onTravelRatesSortOrderChange"
                  >
                    {{ $t('projects.details.travelRates.labels.pay') }}
                  </th-sortable>
                  <th-sortable
                    :direction="
                      currentSortFieldForTravelRates === 'client_rate'
                        ? currentSortDirectionForTravelRates
                        : 'none'
                    "
                    field-name="client_rate"
                    @change="onTravelRatesSortOrderChange"
                  >
                    {{ $t('projects.details.travelRates.labels.bill') }}
                  </th-sortable>
                  <th>{{ $t('projects.details.travelRates.labels.comments') }}</th>
                </template>
              </tol-table>
            </div>
            <div v-if="isListDisplayed['TRAVEL_RATES'] && project.travel_rates.length === 0">
              <div class="empty">
                {{ $t('projects.details.errors.noRecords', { record: 'Travel Rates' }) }}
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="project-status" :class="statusClass">{{ project.status }}</div>
    </div>
    <update-modal v-if="isLoading">
      <template v-slot:modalData>
        <vue-simple-spinner size="massive" />
      </template>
    </update-modal>
    <ConfirmModal
      v-if="isDeleteAttachmentModalDisplayed"
      action="DELETE_ATTACHMENT"
      :title="$t('attachments.confirmDeleteTitle')"
      @continue-action="deleteAttachment()"
      @cancel-action="cancelDeletingAttachment()"
    >
      <template v-slot:modalMessage>
        {{ $t('attachments.confirmDelete') }}
      </template>
    </ConfirmModal>
    <CreateEventTypeModal
      v-if="isCreateEventTypeModalDisplayed"
      @close="isCreateEventTypeModalDisplayed = false"
      @save="createEventType"
    />
    <MapProjectClientContactModal
      v-if="isDisplayAddClientContactModal"
      :project="project"
      @close="isDisplayAddClientContactModal = false"
      @save="mapClientContact"
    />
    <MapProjectTesContactModal
      v-if="isDisplayAddTesContactModal"
      :project="project"
      @close="isDisplayAddTesContactModal = false"
      @save="mapTesContact"
    />
  </div>
</template>

<script>
import { AppActions } from '@/app/app.keys';
import Attachment from '@/app/components/attachments/Attachment';
import AttachmentsList from '@/app/components/attachments/AttachmentsList';
import { attachmentService } from '@/app/components/attachments/attachment.service';
import ConfirmModal from '@/app/components/ConfirmModal';
import CreateEventTypeModal from './components/CreateEventTypeModal.vue';
import { dateUtils } from '@/mixins/date-utils';
import formatDateTime from '@/filters/format-datetime.filter.js';
import { ProjectDetailsActions, ProjectDetailsGetters } from './project-details.keys.js';
import ProjectDetailsForm from './components/ProjectDetailsForm.vue';
import Status from '@/app/components/Status';
import ThSortable from '@/app/components/ThSortable';
import TolButton from '@/app/components/TolButton';
import TolTable from '@/app/components/TolTable';
import UpdateModal from '@/app/components/UpdateModal';
import MapProjectClientContactModal from './components/MapProjectClientContactModal.vue';
import MapProjectTesContactModal from './components/MapProjectTesContactModal.vue';
export default {
  name: 'ProjectDetails',
  components: {
    Attachment,
    AttachmentsList,
    ConfirmModal,
    CreateEventTypeModal,
    MapProjectClientContactModal,
    MapProjectTesContactModal,
    ProjectDetailsForm,
    Status,
    ThSortable,
    TolButton,
    TolTable,
    UpdateModal
  },
  mixins: [dateUtils],
  data() {
    return {
      isListDisplayed: {
        TECHNICIANS: false,
        ATTACHMENTS: false,
        EVENT_TYPES: false,
        PURCHASE_ORDERS: false,
        TRAVEL_RATES: false
      },
      isDeleteAttachmentModalDisplayed: false,
      isCreateEventTypeModalDisplayed: false,
      isDisplayAddClientContactModal: false,
      isDisplayAddTesContactModal: false,
      selectedAttachmentId: null,
      contactsColumns: ['role', 'first_name', 'last_name', 'email', 'phone_number'],
      techniciansColumns: ['first_name', 'last_name', 'email', 'phone_number', 'comments'],
      attachmentOptions: [
        'Resource Request (PS)',
        'SoW (PS)',
        'Travel Policy (PS)',
        'Quote (PS)',
        'Other'
      ],
      eventTypesColumns: ['name', 'estimated_hours_onsite', 'scope_of_work', 'status', 'comments'],
      purchaseOrdersColumns: ['purchase_order_number', 'start_date', 'end_date', 'comments'],
      travelRatesColumns: [
        'description',
        'fixed_or_actual',
        'technician_rate',
        'client_rate',
        'comments'
      ]
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    isLoading() {
      return this.$store.getters[ProjectDetailsGetters.IsProjectDetailsLoading];
    },
    iconFor() {
      return toggle => (toggle ? 'eye' : 'eye-slash');
    },
    toggleTechnicians() {
      return this.isListDisplayed['TECHNICIANS']
        ? this.$t('projects.details.labels.hideTechnicians')
        : this.$t('projects.details.labels.showTechnicians');
    },
    toggleAttachments() {
      return this.isListDisplayed['ATTACHMENTS']
        ? this.$t('projects.details.labels.hideAttachments')
        : this.$t('projects.details.labels.showAttachments');
    },
    toggleEventTypes() {
      return this.isListDisplayed['EVENT_TYPES']
        ? this.$t('projects.details.labels.hideEventTypes')
        : this.$t('projects.details.labels.showEventTypes');
    },
    togglePurchaseOrders() {
      return this.isListDisplayed['PURCHASE_ORDERS']
        ? this.$t('projects.details.labels.hidePurchaseOrders')
        : this.$t('projects.details.labels.showPurchaseOrders');
    },
    toggleTravelRates() {
      return this.isListDisplayed['TRAVEL_RATES']
        ? this.$t('projects.details.labels.hideTravelRates')
        : this.$t('projects.details.labels.showTravelRates');
    },
    isTesEmployee() {
      return (
        this.currentUser &&
        this.currentUser.roles.map(r => r.role_name).some(role => role === 'TES Employee')
      );
    },
    statusClass() {
      let className = '';
      switch (this.project.status) {
        case 'ACTIVE':
          className = 'active';
          break;
        case 'INACTIVE':
          className = 'inactive';
          break;
        case 'RECONCILED':
          className = 'reconciled';
          break;
        case 'COMPLETED':
          className = 'completed';
          break;
      }
      return className;
    },
    project: {
      get() {
        return this.$store.getters[ProjectDetailsGetters.CurrentProject];
      }
    },
    projectAttachments() {
      return this.$store.getters[ProjectDetailsGetters.CurrentProjectAttachments];
    },
    currentSortFieldForClientContacts() {
      return this.$store.getters[ProjectDetailsGetters.ProjectClientContactsSortOrder].sortBy;
    },
    currentSortDirectionForClientContacts() {
      return this.$store.getters[ProjectDetailsGetters.ProjectClientContactsSortOrder]
        .sortDirection;
    },
    currentSortFieldForTESContacts() {
      return this.$store.getters[ProjectDetailsGetters.ProjectTESContactsSortOrder].sortBy;
    },
    currentSortDirectionForTESContacts() {
      return this.$store.getters[ProjectDetailsGetters.ProjectTESContactsSortOrder].sortDirection;
    },
    currentSortFieldForTechnicians() {
      return this.$store.getters[ProjectDetailsGetters.ProjectTechniciansSortOrder].sortBy;
    },
    currentSortDirectionForTechnicians() {
      return this.$store.getters[ProjectDetailsGetters.ProjectTechniciansSortOrder].sortDirection;
    },
    currentSortFieldForEventTypes() {
      return this.$store.getters[ProjectDetailsGetters.ProjectEventTypesSortOrder].sortBy;
    },
    currentSortDirectionForEventTypes() {
      return this.$store.getters[ProjectDetailsGetters.ProjectEventTypesSortOrder].sortDirection;
    },
    currentSortFieldForPurchaseOrders() {
      return this.$store.getters[ProjectDetailsGetters.ProjectPurchaseOrdersSortOrder].sortBy;
    },
    currentSortDirectionForPurchaseOrders() {
      return this.$store.getters[ProjectDetailsGetters.ProjectPurchaseOrdersSortOrder]
        .sortDirection;
    },
    currentSortFieldForTravelRates() {
      return this.$store.getters[ProjectDetailsGetters.ProjectTravelRatesSortOrder].sortBy;
    },
    currentSortDirectionForTravelRates() {
      return this.$store.getters[ProjectDetailsGetters.ProjectTravelRatesSortOrder].sortDirection;
    },
    canViewAttachments() {
      return (
        this.currentUser &&
        this.currentUser.permissions &&
        this.currentUser.permissions['PROJECT']['VIEW_ATTACHMENT']
      );
    },
    objectHeader() {
      const data = {
        referenceNumber: this.project.reference_number,
        objectStatus: this.project.status,
        objectType: 'PROJECT',
        lastModified: null
      };
      const lastModified = `${formatDateTime(this.project.updated_dt)}`;
      if (this.isTesEmployee) {
        data.lastModified = lastModified;
      }
      return data;
    }
  },
  watch: {
    $route: {
      immediate: true,
      async handler(val) {
        this.$store.dispatch(ProjectDetailsActions.FetchProject, val.params.reference_number);
        if (this.isListDisplayed['ATTACHMENTS']) {
          this.$store.dispatch(
            ProjectDetailsActions.FetchProjectAttachments,
            this.$route.params.reference_number
          );
        }
      }
    }
  },
  mounted() {
    this.$store.dispatch(AppActions.SetPageTitle, this.$t('projects.details.title'));
    this.$store.dispatch(ProjectDetailsActions.FetchProject, this.$route.params.reference_number);
  },
  methods: {
    onContactRowClick(event) {
      this.$router.push(`/users/${event.user_reference_number}`);
    },
    addClientContact() {
      this.isDisplayAddClientContactModal = true;
    },
    addTesContact() {
      this.isDisplayAddTesContactModal = true;
    },
    onTechnicianRowClick(event) {
      this.$router.push(`/contractors/${event.contractor_reference_number}`);
    },
    onPurchaseOrderRowClick(event) {
      this.$router.push(`/purchase_orders/${event.purchase_order_reference_number}`);
    },
    toggleList(item) {
      this.isListDisplayed[item] = !this.isListDisplayed[item];
      if (item === 'ATTACHMENTS' && this.isListDisplayed[item]) {
        this.$store.dispatch(
          ProjectDetailsActions.FetchProjectAttachments,
          this.$route.params.reference_number
        );
      }
    },
    confirmAttachmentDelete(attachmentId) {
      this.selectedAttachmentId = attachmentId;
      this.isDeleteAttachmentModalDisplayed = true;
    },
    async deleteAttachment() {
      await attachmentService.deleteAttachment(this.selectedAttachmentId);
      this.isDeleteAttachmentModalDisplayed = false;
      this.selectedAttachmentId = null;
      this.refreshAttachments();
    },
    cancelDeletingAttachment() {
      this.isDeleteAttachmentModalDisplayed = false;
      this.selectedAttachmentId = null;
    },
    async createEventType(eventType) {
      this.$store.dispatch(ProjectDetailsActions.CreateEventType, {
        projectReferenceNumber: this.$route.params.reference_number,
        eventType
      });
      this.isCreateEventTypeModalDisplayed = false;
    },
    mapClientContact(projectClientContact) {
      this.$store.dispatch(ProjectDetailsActions.SaveProjectClientContact, projectClientContact);
      this.isDisplayAddClientContactModal = false;
    },
    mapTesContact(projectTesContact) {
      this.$store.dispatch(ProjectDetailsActions.SaveProjectTesContact, projectTesContact);
      this.isDisplayAddTesContactModal = false;
    },
    onClientContactsSortOrderChange(sortOrder) {
      this.$store.dispatch(ProjectDetailsActions.SetProjectClientContactsSortOrder, sortOrder);
    },
    onTESContactsSortOrderChange(sortOrder) {
      this.$store.dispatch(ProjectDetailsActions.SetProjectTESContactsSortOrder, sortOrder);
    },
    onTechniciansSortOrderChange(sortOrder) {
      this.$store.dispatch(ProjectDetailsActions.SetProjectTechniciansSortOrder, sortOrder);
    },
    onEventTypesSortOrderChange(sortOrder) {
      this.$store.dispatch(ProjectDetailsActions.SetProjectEventTypesSortOrder, sortOrder);
    },
    onPurchaseOrdersSortOrderChange(sortOrder) {
      this.$store.dispatch(ProjectDetailsActions.SetProjectPurchaseOrdersSortOrder, sortOrder);
    },
    onTravelRatesSortOrderChange(sortOrder) {
      this.$store.dispatch(ProjectDetailsActions.SetProjectTravelRatesSortOrder, sortOrder);
    },
    refreshAttachments() {
      this.$store.dispatch(
        ProjectDetailsActions.FetchProjectAttachments,
        this.$route.params.reference_number
      );
    },
    onEventTypeRowClick(event) {
      this.$router.push(
        `/projects/${this.project.reference_number}/event-types/${event.reference_number}`
      );
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.details-wrapper {
  display: flex;
  flex-direction: column;
  background-color: $background-level-2;

  .details-body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-right: 4px solid rgba(255, 255, 255, 0);
    &.modified {
      border-right: 4px solid $modified-form;
    }

    .content-panel-wrapper {
      padding: 0 1.5rem;

      .content-panel {
        display: block;
        background-color: $white;
        padding: 60px 0;
      }
    }

    .details-section {
      margin-bottom: 25px;

      h1 {
        border-bottom: 1px solid $row-border;
      }

      .details-list {
        margin-top: 1rem;
      }

      .create-event-type-button-container {
        padding-left: 60px;
      }

      .add {
        display: flex;
        justify-content: flex-end;
        span {
          display: inline-block;
          font-size: 1.2em;
          font-weight: bold;
          width: 20px;
          height: 20px;
          line-height: 20px;
          border-radius: 100%;
          text-align: center;
          &:hover {
            cursor: pointer;
            background-color: $light-grey-2;
          }
          &.history {
            display: none;
          }
        }
      }
    }

    .project-status {
      position: fixed;
      width: 170px;
      padding: 10px 0;
      transform: rotate(-90deg);
      top: 50%;
      right: 0;
      color: $white;
      font-weight: bold;
      text-align: center;
      &.active {
        background-color: $secondary-green;
        border: 1px solid $green;
      }
      &.inactive {
        background-color: $purple;
        border: 1px solid $purple;
      }
      &.reconciled {
        background-color: $orange;
        border: 1px solid $secondary-orange;
      }
      &.completed {
        background-color: $blue;
        border: 1px solid $dark-blue;
      }
    }

    .details-table {
      margin-bottom: 1rem;
    }
  }

  .empty {
    display: flex;
    padding: 60px;
  }
}
</style>
